import {
  ChartReports,
  Filters,
  RecentLeads,
  SalesFunnel,
  TasksCards
} from '@crm/features/dashboard/components'
import { TitleSection } from '@shared/components'
import { useLocales } from '@shared/locales'

import { Col, Flex, Row } from 'antd'

export const Dashboard = () => {
  const { t } = useLocales()

  return (
    <>
      <TitleSection title={t('menu.dashboard')} />

      <Flex vertical gap={16}>
        <Filters />

        <TasksCards />
      </Flex>

      <Row gutter={[16, 16]} className="mb-15">
        <Col span={24} md={12}>
          <RecentLeads />
        </Col>

        <Col span={24} md={12}>
          <SalesFunnel />
        </Col>

        <Col span={24}>
          <ChartReports />
        </Col>
      </Row>
    </>
  )
}
